define('angular',["angular"], function (angular) {
	function curryMap(iteratorName) {
		return function map(obj, iterator, context) {
			var newObj = obj;
			if (angular.isObject(obj)) {
				if (angular.isArray(obj)) {
					newObj = [];
				}
				else {
					newObj = {};
				}
				this[iteratorName](obj, mapIterator, context);
			}
			return newObj;
			function mapIterator(value, key, context) {
				newObj[key] = iterator.apply(this, arguments);
			}
		};
	}
	function curryMapMany(iteratorName) {
		return function mapMany(obj, iterator, context) {
			var newObj = obj,
				isArray;
			if (angular.isObject(obj)) {
				if (isArray = angular.isArray(obj)) {
					newObj = [];
				}
				else {
					newObj = {};
				}
				this[iteratorName](obj, mapManyIterator, context);
			}
			return newObj;
			function mapManyIterator(value, key) {
				var result = iterator.apply(this, arguments);
				if (isArray) {
					Array.prototype.push.apply(newObj, result);
				}
				else {
					angular.extend(newObj, result);
				}
			}
		};
	}
	function curryMapKeyValuePair(iteratorName) {
		return function mapKeyValuePair(obj, iterator, context) {
			var newObj = obj;
			if (angular.isObject(obj)) {
				newObj = {};
				this[iteratorName](obj, mapKeyValuePairIterator, context);
			}
			return newObj;
			function mapKeyValuePairIterator(value, key) {
				var iteratorResult = iterator.apply(this, arguments);
				if (angular.isArray(iteratorResult)) {
					if (iteratorResult.length === 2) {
						newObj[iteratorResult[0]] = iteratorResult[1];
					}
				}
				else if (iteratorResult) {
					newObj[iteratorResult.key] = iteratorResult.value;
				}
			}
		};
	}
	function curryFilter(iteratorName) {
		function nullFilterIterator(value) {
			return !!value;
		}
		return function filter(obj, iterator, context) {
			var set, newObj = obj;
			if (!iterator) {
				iterator = nullFilterIterator;
			}
			if (angular.isObject(obj)) {
				if (angular.isArray(obj)) {
					newObj = [];
					set = arraySet;
				}
				else {
					newObj = {};
					set = objectSet;
				}
				this[iteratorName](obj, filterIterator, context);
			}
			return newObj;

			function filterIterator(value, key) {
				if (iterator.apply(this, arguments)) {
					set(key, value);
				}
			}
			function arraySet(key, value) {
				newObj.push(value);
			}
			function objectSet(key, value) {
				newObj[key] = value;
			}
		};
	}
	function curryReduce(iteratorName) {
		return function reduce(obj, initial, iterator, context) {
			var prev, hasInitial;
			switch (arguments.length) {
				case 2:
					iterator = initial;
					initial = undefined;
					context = obj;
					hasInitial = false;
					break;
				case 3:
					context = obj;
					hasInitial = true;
					break;
				case 4:
					hasInitial = true;
					break;
			}
			if (hasInitial) {
				prev = initial;
			}
			if (obj) {
				this[iteratorName](obj, filterIterator, context);
			}
			return prev;

			function filterIterator(curr, key) {
				prev = iterator.call(this, prev, curr, key, context);
			}
		};
	}
	function isRegExp(value) {
		return toString.call(value) === '[object RegExp]';
	}
	var TYPED_ARRAY_REGEXP = /^\[object (Uint8(Clamped)?)|(Uint16)|(Uint32)|(Int8)|(Int16)|(Int32)|(Float(32)|(64))Array\]$/;
	function isTypedArray(value) {
		return TYPED_ARRAY_REGEXP.test(toString.call(value));
	}
	function filteredCopy(value, filter) {
		return _filteredCopy(value, filter, new Map());
	}
	function _filteredCopy(value, filter, seen) {
		if (seen.has(value)) {
			return seen.get(value);
		}
		else {
			if (!angular.isObject(value) || angular.isDate(value) || angular.isRegExp(value) || angular.isFunction(value) || angular.isTypedArray(value)) {
				return angular.copy(value);
			}
			else {
				var newObj;
				if (angular.isArray(value)) {
					newObj = [];
				}
				else {
					newObj = {};
				}
				seen.set(value, newObj);
				return angular.extend(newObj, angular.map(angular.filter(value, filter), function (value) {
					return _filteredCopy(value, filter, seen);
				}));
			}
		}
	}
	function arrayRemove(array, value) {
		var index = array.indexOf(value);
		if (index >= 0) {
			array.splice(index, 1);
		}
		return index;
	}
	var emptyObject = Object.freeze({}),
		emptyArray = Object.freeze([]);
	return angular.extend(angular, {
		map: curryMap("forEach"),
		mapSorted: curryMap("forEachSorted"),
		mapMany: curryMapMany("forEach"),
		mapManySorted: curryMapMany("forEachSorted"),
		reduce: curryReduce("forEach"),
		reduceSorted: curryReduce("forEachSorted"),
		mapKeyValuePair: curryMapKeyValuePair("forEach"),
		mapKeyValuePairSorted: curryMapKeyValuePair("forEachSorted"),
		filter: curryFilter("forEach"),
		filterSorted: curryFilter("forEachSorted"),
		isRegExp: isRegExp,
		arrayRemove: arrayRemove,
		isTypedArray: isTypedArray,
		filteredCopy: filteredCopy,
		element: angular.merge(angular.element, {
			fn: {
				getBlockNodes: function getBlockNodes() {
					// TODO(perf): just check if all items in `nodes` are siblings and if they are return the original
					//             collection, otherwise update the original collection.
					var node = this[0];
					var endNode = this[this.length - 1];
					var blockNodes = [node];

					do {
						node = node.nextSibling;
						if (!node) break;
						blockNodes.push(node);
					} while (node !== endNode);

					return angular.element(blockNodes);
				}
			}
		}),
		emptyObject: emptyObject,
		emptyArray: emptyArray,
		empty: emptyObject
	});
});
